var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgIcCallMissedOutgoing = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "14px",
    height: "8px",
    viewBox: "0 0 14 8",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "harahator",
    x: 0,
    y: 0,
    width: 1280,
    height: 1484
  }), /*#__PURE__*/React.createElement("filter", {
    x: "-0.4%",
    y: "-0.3%",
    width: "100.8%",
    height: "100.7%",
    filterUnits: "objectBoundingBox",
    id: "harahator5"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 0,
    dy: 1,
    in: "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.5,
    in: "shadowOffsetOuter1",
    result: "shadowBlurOuter1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0   0 0 0 0 0   0 0 0 0 0  0 0 0 0.2 0",
    type: "matrix",
    in: "shadowBlurOuter1",
    result: "shadowMatrixOuter1"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 0.5,
    operator: "erode",
    in: "SourceAlpha",
    result: "shadowSpreadOuter2"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 0,
    dy: 2,
    in: "shadowSpreadOuter2",
    result: "shadowOffsetOuter2"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.5,
    in: "shadowOffsetOuter2",
    result: "shadowBlurOuter2"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0   0 0 0 0 0   0 0 0 0 0  0 0 0 0.12 0",
    type: "matrix",
    in: "shadowBlurOuter2",
    result: "shadowMatrixOuter2"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 0,
    dy: 1,
    in: "SourceAlpha",
    result: "shadowOffsetOuter3"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.5,
    in: "shadowOffsetOuter3",
    result: "shadowBlurOuter3"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0   0 0 0 0 0   0 0 0 0 0  0 0 0 0.14 0",
    type: "matrix",
    in: "shadowBlurOuter3",
    result: "shadowMatrixOuter3"
  }), /*#__PURE__*/React.createElement("feMerge", null, /*#__PURE__*/React.createElement("feMergeNode", {
    in: "shadowMatrixOuter1"
  }), /*#__PURE__*/React.createElement("feMergeNode", {
    in: "shadowMatrixOuter2"
  }), /*#__PURE__*/React.createElement("feMergeNode", {
    in: "shadowMatrixOuter3"
  }))), /*#__PURE__*/React.createElement("rect", {
    id: "harahator2",
    x: 0,
    y: 0,
    width: 1220,
    height: 42
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "harahator3",
    points: "2.25 6.3075 9 13.0575 14.25 7.8075 14.25 11.25 15.75 11.25 15.75 5.25 9.75 5.25 9.75 6.75 13.1925 6.75 9 10.9425 3.3075 5.25"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "harahator4",
    x: 0,
    y: 0,
    width: 37.5,
    height: 37.5
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "harahator6",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "harahator7",
    transform: "translate(-1096.000000, -582.000000)"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "#FFFFFF",
    x: 0,
    y: 0,
    width: 1440,
    height: 1703
  }), /*#__PURE__*/React.createElement("rect", {
    id: "harahator8",
    stroke: "#DFE2E5",
    fill: "#F7F8FA",
    x: -0.5,
    y: 123.5,
    width: 1441,
    height: 1580
  }), /*#__PURE__*/React.createElement("g", {
    id: "harahator9",
    transform: "translate(80.000000, 139.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "harahator10"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "black",
    fillOpacity: 1,
    filter: "url(#harahator5)",
    xlinkHref: "#harahator"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "#FFFFFF",
    fillRule: "evenodd",
    xlinkHref: "#harahator"
  })), /*#__PURE__*/React.createElement("g", {
    id: "harahator11",
    transform: "translate(30.000000, 384.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "harahator12",
    transform: "translate(0.000000, 42.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "harahator13",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#harahator2"
  })), /*#__PURE__*/React.createElement("use", {
    id: "harahator14",
    fill: "#FFFFFF",
    xlinkHref: "#harahator2"
  }), /*#__PURE__*/React.createElement("g", {
    id: "harahator15-10",
    mask: "url(#harahator13)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(369.000000, 12.000000)",
    id: "harahator15-29"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(615.000000, 0.000000)",
    id: "harahator20"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "harahator17",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#harahator3"
  })), /*#__PURE__*/React.createElement("g", {
    id: "harahator14"
  }), /*#__PURE__*/React.createElement("g", {
    id: "harahator15",
    mask: "url(#harahator17)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-9.750000, -9.750000)",
    id: "harahator16"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "harahator19",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#harahator4"
  })), /*#__PURE__*/React.createElement("use", {
    id: "harahator18",
    fill: "#908A11",
    xlinkHref: "#harahator4"
  })))))))))))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgIcCallMissedOutgoing, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/ic-call-missed-outgoing.fe9bd9ff.svg";
export { ForwardRef as ReactComponent };